import { createElement } from 'react';

export default function fork(element, withProps) {
    // eslint-disable-next-line react/display-name, react/prop-types
    return ({ children, ...props }) => createElement(element, withProps(props), children);
}
